// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer ici. Source : shared/ui/ · régénérer avec `bash shared/sync.sh`
/**
 * LES LIBELLÉS DES PROFILS — une seule définition pour la suite (RQ, 05/10/2026).
 *
 * « Technicien » était faux pour une secrétaire, un comptable ou un coursier ;
 * « Responsable » se confondait avec le RÔLE « Responsable de service » et avec
 * le responsable technique. Les profils deviennent :
 *   technician → Base · manager → Admin · superadmin → Super admin.
 *
 * ⚠️ SEULS LES LIBELLÉS CHANGENT. Les CLÉS (`technician`, `manager`,
 * `superadmin`, `partner`, `public`) sont écrites dans chaque compte
 * (`up_users.profile`) et lues par toutes les gardes : on n'y touche pas.
 *
 * Ce fichier est la source des écrans de Qualité, du site et du catalogue.
 * Le moteur en garde une copie pour son amorçage (`backend/src/index.ts`,
 * `ROLEMETA`) — les deux doivent dire la même chose.
 */
export type CleProfil = 'technician' | 'manager' | 'superadmin' | 'partner' | 'public';

export const LIBELLES_PROFILS: Record<CleProfil, { label: string; aide: string }> = {
  technician: { label: 'Base', aide: 'Le niveau de départ : le plateau technique et les registres qui s’y rattachent.' },
  manager: { label: 'Admin', aide: 'Le pilotage en plus : revue, audits, objectifs. Ne crée pas les comptes.' },
  superadmin: { label: 'Super admin', aide: 'Tous les droits, dont le paramétrage et la création des comptes.' },
  /* 16/10/2026 (Ines) : « Confrère » → « Correspondant ». Le compte externe n'est
     plus seulement un laboratoire ; il se relie à une ligne du carnet des
     correspondants (laboratoire, médecin, clinique, préleveur), et c'est cette
     ligne qui décide de ce qu'il lit au catalogue. */
  partner: { label: 'Correspondant', aide: 'Laboratoire, médecin prescripteur, clinique ou préleveur extérieur : le catalogue des analyses, jamais la Qualité. À relier au carnet des correspondants.' },
  public: { label: 'Visiteur', aide: 'Aucun accès réservé. Sert à retirer les droits sans supprimer le compte.' },
};

export const libelleDuProfil = (cle: string): string =>
  (LIBELLES_PROFILS as Record<string, { label: string }>)[cle]?.label || cle;
